import React from 'react';

import { FeatureExplanationBlock } from '@models/feature-explanation';

import { TextExplanationBlock } from './components/TextExplanationBlock';
import { ColumnExplanationBlock } from './components/ColumnExplanationBlock';
import { PetExplanationBlock } from './components/PetExplanationBlock';
import { DataSlotExplanationBlock } from './components/DataSlotExplanationBlock';
import { TopicExplanationBlock } from './components/TopicExplanationBlock';
import { TextWithDataSlotContextExplanationBlock } from './components/TextWithDataSlotContextExplanationBlock';
import { UnknownExplanationBlock } from './components/UnknownExplanationBlock';

interface FeatureExplanationProps {
  explanationBlocks: FeatureExplanationBlock[];
}

const FeatureExplanationInternal: React.FC<FeatureExplanationProps> = ({
  explanationBlocks,
}) => {
  return (
    <>
      {explanationBlocks.map(block => {
        if (FeatureExplanationBlock.isTextExplanationBlock(block)) {
          return <TextExplanationBlock {...block} />;
        } else if (FeatureExplanationBlock.isColumnExplanationBlock(block)) {
          return <ColumnExplanationBlock {...block} />;
        } else if (FeatureExplanationBlock.isDataSlotExplanationBlock(block)) {
          return <DataSlotExplanationBlock {...block} />;
        } else if (FeatureExplanationBlock.isPetExplanationBlock(block)) {
          return <PetExplanationBlock {...block} />;
        } else if (
          FeatureExplanationBlock.isTextWithDataSlotContextExplanationBlock(
            block
          )
        ) {
          return <TextWithDataSlotContextExplanationBlock {...block} />;
        } else if (FeatureExplanationBlock.isTopicExplanationBlock(block)) {
          return <TopicExplanationBlock {...block} />;
        } else if (FeatureExplanationBlock.isOperatorExplanationBlock(block)) {
          return (
            <FeatureExplanationInternal
              explanationBlocks={block.tokens.map(token => ({
                ...token,
                pathType: block.type,
              }))}
            />
          );
        } else {
          return <UnknownExplanationBlock {...(block as any)} />;
        }
      })}
    </>
  );
};

export const FeatureExplanation: React.FC<FeatureExplanationProps> = ({
  explanationBlocks,
}) => {
  return (
    <span style={{ whiteSpace: 'nowrap' }}>
      <FeatureExplanationInternal explanationBlocks={explanationBlocks} />
    </span>
  );
};
